import React, { useRef, useEffect } from 'react';

var jsxRuntime = {exports: {}};

var reactJsxRuntime_production_min = {};

/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var f=React,k=Symbol.for("react.element"),l=Symbol.for("react.fragment"),m=Object.prototype.hasOwnProperty,n=f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,p={key:!0,ref:!0,__self:!0,__source:!0};
function q(c,a,g){var b,d={},e=null,h=null;void 0!==g&&(e=""+g);void 0!==a.key&&(e=""+a.key);void 0!==a.ref&&(h=a.ref);for(b in a)m.call(a,b)&&!p.hasOwnProperty(b)&&(d[b]=a[b]);if(c&&c.defaultProps)for(b in a=c.defaultProps,a)void 0===d[b]&&(d[b]=a[b]);return {$$typeof:k,type:c,key:e,ref:h,props:d,_owner:n.current}}reactJsxRuntime_production_min.Fragment=l;reactJsxRuntime_production_min.jsx=q;reactJsxRuntime_production_min.jsxs=q;

{
  jsxRuntime.exports = reactJsxRuntime_production_min;
}

const jsx = jsxRuntime.exports.jsx;
const jsxs = jsxRuntime.exports.jsxs;
const Fragment = jsxRuntime.exports.Fragment;

const AccountCenterReact = React;
const AccountCenter = ({
  appEnvironment,
  widgetEnvironment,
  locale,
  user,
  navigateAs,
  navigateAsSelectUser,
  stopNavigationAs
}) => {
  var _a, _b;
  const inputEl = useRef();
  if (navigateAsSelectUser) {
    (_a = inputEl.current) === null || _a === void 0 ? void 0 : _a.addEventListener("sgwt-account-center--navigate-as-select-user", (evt) => {
      const event = evt;
      if (event) {
        navigateAsSelectUser(event.detail.user);
      }
    });
  }
  if (stopNavigationAs) {
    (_b = inputEl.current) === null || _b === void 0 ? void 0 : _b.addEventListener("sgwt-account-center--stop-navigation-as", (evt) => {
      const event = evt;
      if (event) {
        stopNavigationAs(event.detail.user);
      }
    });
  }
  useEffect(() => {
    if (inputEl.current && typeof inputEl.current.setUser !== "undefined") {
      inputEl.current.widgetConfiguration.environment = widgetEnvironment;
    }
  }, [inputEl.current]);
  const otherProps = {
    authentication: "sg-connect-v2"
  };
  if (user) {
    otherProps.user = JSON.stringify(user);
    delete otherProps.authentication;
  }
  if (navigateAs && !((appEnvironment === null || appEnvironment === void 0 ? void 0 : appEnvironment.toLocaleLowerCase()) === "prod" || (appEnvironment === null || appEnvironment === void 0 ? void 0 : appEnvironment.toLocaleLowerCase()) === "production")) {
    otherProps["navigate-as"] = "";
    otherProps["navigate-as-list"] = JSON.stringify(navigateAs);
  }
  return jsx("sgwt-account-center", Object.assign({
    ref: inputEl,
    "available-languages": "fr,en,ru",
    mode: "sg-markets",
    language: locale,
    environment: (appEnvironment === null || appEnvironment === void 0 ? void 0 : appEnvironment.toLocaleLowerCase()) === "prod" || (appEnvironment === null || appEnvironment === void 0 ? void 0 : appEnvironment.toLocaleLowerCase()) === "production" ? "" : appEnvironment
  }, otherProps));
};

class KeyDataModel {
  constructor(parent, propertyName) {
    Object.defineProperty(this, "Value", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "Parent", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "PropertyName", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "ModelStateUpdater", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    this.Parent = parent;
    this.PropertyName = propertyName;
    this.ModelStateUpdater = void 0;
  }
  getJsonPatch() {
    if (this.Value === void 0 || !this.PropertyName) {
      return void 0;
    }
    let result = {};
    const pathList = [];
    pathList.push(this.PropertyName);
    result[this.PropertyName] = this.Value;
    let nextNode = this.Parent;
    while (nextNode != void 0) {
      if (nextNode instanceof ObjectDataModel && nextNode.InputContract.isGroup()) {
        nextNode = nextNode.Parent;
      } else if (nextNode.PropertyName) {
        let parentNodeResult = {};
        parentNodeResult[nextNode.PropertyName] = result;
        pathList.push(nextNode.PropertyName);
        result = parentNodeResult;
        nextNode = nextNode.Parent;
      } else {
        nextNode = void 0;
      }
    }
    let path = "";
    let part = pathList.pop();
    while (part) {
      path = `${path}/${part}`;
      part = pathList.pop();
    }
    console.info(`Path to update : ${path}`);
    return result;
  }
}

class ObjectDataModel {
  constructor(inputContract, parent) {
    Object.defineProperty(this, "Fields", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "Parent", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "PropertyName", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "InputContract", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    this.Fields = /* @__PURE__ */ new Map();
    this.Parent = parent;
    this.PropertyName = inputContract.propertyName;
    this.InputContract = inputContract;
    inputContract.properties.forEach((property) => {
      if (!this.Fields.has(property.propertyName)) {
        if (property.isObject() || property.isGroup()) {
          this.Fields.set(property.propertyName, new ObjectDataModel(property, this));
        } else if (property.isArray()) {
          this.Fields.set(property.propertyName, new ArrayDataModel(property, this));
        } else {
          this.Fields.set(property.propertyName, new KeyDataModel(this, property.propertyName));
        }
      }
    });
  }
  getJson() {
    let result = {};
    var fields = this.getFlattenedFields(this.Fields);
    fields.forEach((value, name) => {
      if (value instanceof ObjectDataModel) {
        result[name] = value.getJson();
      } else if (value instanceof ArrayDataModel) {
        result[name] = value.getJson();
      } else if (value.Value) {
        result[name] = value.Value;
      }
    });
    return result;
  }
  getFlattenedFields(inputFields) {
    var fields = /* @__PURE__ */ new Map();
    inputFields.forEach((value, name) => {
      if (value instanceof ObjectDataModel && value.InputContract.isGroup()) {
        value.Fields.forEach((val, nam) => {
          fields.set(nam, val);
        });
      } else {
        fields.set(name, value);
      }
    });
    return fields;
  }
  resetModel() {
    this.Fields.forEach((value) => {
      var _a;
      if (value instanceof KeyDataModel) {
        value.Value = void 0;
        (_a = value.ModelStateUpdater) === null || _a === void 0 ? void 0 : _a.call(value);
      } else if (value instanceof ObjectDataModel) {
        value.resetModel();
      } else if (value instanceof ArrayDataModel) {
        value.resetModel();
      }
    });
  }
  applyJsonPatch(jsonPatch) {
    Object.entries(jsonPatch).forEach((entry) => {
      var _a;
      if (this.Fields.has(entry[0])) {
        let fieldValue = this.Fields.get(entry[0]);
        if (fieldValue instanceof ObjectDataModel) {
          let subTradeCaptureModel = entry[1];
          if (subTradeCaptureModel) {
            fieldValue.applyJsonPatch(subTradeCaptureModel);
          } else {
            fieldValue.resetModel();
          }
        } else if (fieldValue instanceof KeyDataModel) {
          fieldValue.Value = entry[1];
          (_a = fieldValue.ModelStateUpdater) === null || _a === void 0 ? void 0 : _a.call(fieldValue);
        } else if (fieldValue instanceof ArrayDataModel) {
          let subTradeCaptureModel = entry[1];
          if (subTradeCaptureModel) {
            fieldValue.applyJsonPatch(subTradeCaptureModel);
          }
        }
      }
    });
    this.Fields.forEach((value) => {
      if (value instanceof ObjectDataModel && value.InputContract.isGroup()) {
        value.applyJsonPatch(jsonPatch);
      }
    });
  }
  getRoot() {
    let currentNode = this;
    while (currentNode.Parent) {
      currentNode = currentNode.Parent;
    }
    return currentNode;
  }
}

class ArrayDataModel {
  constructor(inputContract, parent) {
    Object.defineProperty(this, "Value", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "Parent", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "PropertyName", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "ModelStateUpdater", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "InputContract", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    this.Parent = parent;
    this.PropertyName = inputContract.propertyName;
    this.ModelStateUpdater = void 0;
    this.InputContract = inputContract;
    if (inputContract.arrayItems === void 0) {
      throw new Error("ArrayDataModel cannot be instantiated with an inputContract that doesn't describe arrayItems.");
    }
  }
  resetModel() {
    this.Value = [];
  }
  applyJsonPatch(jsonPatch) {
    var _a;
    if (this.Value) {
      if (jsonPatch.length < this.Value.length) {
        this.Value.splice(jsonPatch.length - 1, this.Value.length - jsonPatch.length);
      }
    } else {
      this.Value = [];
    }
    jsonPatch.forEach((entry, index) => {
      var _a2;
      if (this.Value && !(this.Value[index] instanceof ObjectDataModel)) {
        this.Value[index] = new ObjectDataModel(this.InputContract.arrayItems, this);
      }
      ((_a2 = this.Value) === null || _a2 === void 0 ? void 0 : _a2[index]).applyJsonPatch(entry);
    });
    (_a = this.ModelStateUpdater) === null || _a === void 0 ? void 0 : _a.call(this);
  }
  getJson() {
    var _a;
    let result = [];
    (_a = this.Value) === null || _a === void 0 ? void 0 : _a.forEach((value, index) => {
      if (value instanceof ObjectDataModel) {
        result[index] = value.getJson();
      } else if (value.Value) {
        result[index] = value.Value;
      }
    });
    return result;
  }
}

class DataContract {
  constructor(bookingContractProperty, propertyName) {
    var _a, _b;
    Object.defineProperty(this, "_type", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "nullable", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "properties", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "propertyName", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "title", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "widgetType", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "arrayItems", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "enumValues", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "rank", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "colNumber", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_isReadOnly", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "isHidden", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    this.propertyName = propertyName;
    this.title = (_a = bookingContractProperty.title) !== null && _a !== void 0 ? _a : propertyName;
    this._isReadOnly = bookingContractProperty.readonly;
    this.isHidden = bookingContractProperty.hidden;
    if (bookingContractProperty.rank) {
      this.rank = bookingContractProperty.rank;
    } else {
      this.rank = 9999;
    }
    if (bookingContractProperty.colNumber) {
      this.colNumber = bookingContractProperty.colNumber;
    } else {
      this.colNumber = 3;
    }
    if (Array.isArray(bookingContractProperty.type)) {
      this._type = bookingContractProperty.type[0];
      this.nullable = bookingContractProperty.type[1] == "null";
    } else {
      this._type = bookingContractProperty.type;
      this.nullable = false;
    }
    this.properties = Object.entries((_b = bookingContractProperty.properties) !== null && _b !== void 0 ? _b : []).map((p) => new DataContract(p[1], p[0]));
    if (bookingContractProperty.functionalType && bookingContractProperty.functionalType !== "None" && bookingContractProperty.type !== "array") {
      this.widgetType = bookingContractProperty.functionalType;
    } else {
      this.widgetType = Array.isArray(bookingContractProperty.type) ? bookingContractProperty.type[0] : bookingContractProperty.type;
    }
    if (bookingContractProperty.items) {
      this.arrayItems = new DataContract(bookingContractProperty.items, this.propertyName);
    }
    if (bookingContractProperty.enum) {
      this.enumValues = bookingContractProperty.enum;
    }
  }
  isObject() {
    return this._type == "object";
  }
  isArray() {
    return this._type == "array";
  }
  isScalar() {
    return this._type != "object" && this._type != "array" && this._type != "group";
  }
  isGroup() {
    return this._type == "group";
  }
  isReadOnly() {
    if (this._isReadOnly) {
      return this._isReadOnly;
    }
    return this.propertyName == "PeriodNumber";
  }
}

const DynamicScreenContext = React.createContext({
  applyPatch: () => void 0
});

const ScalarComponent = (props) => {
  const getAsInternalValue = (value) => {
    if (value === void 0 || value === null) {
      return "";
    }
    if (props.inputContract.widgetType === "Date" && value === "0001-01-01") {
      return "1970-01-01";
    }
    if (props.inputContract.widgetType === "Tenor" && value === "0N") {
      return "";
    }
    return value;
  };
  const [internalValue, setInternalValue] = React.useState(getAsInternalValue(props.inputContract.widgetType === "string" && props.inputContract.enumValues && props.inputContract.enumValues.indexOf(props.objectModel.Value) === -1 ? props.inputContract.enumValues[0] : props.objectModel.Value));
  const {
    applyPatch
  } = React.useContext(DynamicScreenContext);
  const updateInternalValue = (value) => {
    if (props.inputContract.widgetType === "integer") {
      setInternalValue(Number(value));
    } else if (props.inputContract.widgetType === "boolean") {
      setInternalValue(value === "true");
    } else {
      setInternalValue(value);
    }
  };
  const refreshObjectModelValue = () => {
    setInternalValue(getAsInternalValue(props.objectModel.Value));
  };
  useEffect(() => {
    if (props.objectModel.ModelStateUpdater) {
      console.error(`dynamic-screen scalar component: ${props.propertyName} already bound`);
    } else {
      props.objectModel.ModelStateUpdater = refreshObjectModelValue.bind(void 0);
    }
    return () => props.objectModel.ModelStateUpdater = void 0;
  }, [props.objectModel]);
  const checkIfValueChanged = () => {
    const valueToCompare = props.inputContract.widgetType === "number" || props.inputContract.widgetType === "Notional" ? Number(internalValue) : internalValue;
    if (getAsInternalValue(props.objectModel.Value) !== valueToCompare) {
      props.objectModel.Value = valueToCompare;
      const jsonPatchMessage = props.objectModel.getJsonPatch();
      if (jsonPatchMessage) {
        applyPatch(jsonPatchMessage);
      }
    }
  };
  if (props.inputContract.widgetType === "Date") {
    return jsxs(Fragment, {
      children: [props.showLabels && jsx("label", Object.assign({
        className: "text-secondary",
        htmlFor: props.propertyName
      }, {
        children: props.inputContract.title
      })), !props.showLabels ? jsx(Fragment, {
        children: new Date(internalValue).toLocaleDateString("sv-SE")
      }) : jsx("input", {
        id: props.propertyName,
        type: "date",
        readOnly: props.inputContract.isReadOnly(),
        className: "form-control",
        value: new Date(internalValue).toLocaleDateString("sv-SE"),
        onChange: (e) => updateInternalValue(e.target.value),
        onBlur: checkIfValueChanged
      })]
    });
  }
  if (props.inputContract.widgetType === "DateTime") {
    return jsxs(Fragment, {
      children: [props.showLabels && jsx("label", Object.assign({
        className: "text-secondary",
        htmlFor: props.propertyName
      }, {
        children: props.inputContract.title
      })), !props.showLabels ? jsx(Fragment, {
        children: new Date(internalValue).toLocaleString("sv-SE")
      }) : jsx("input", {
        id: props.propertyName,
        type: "date",
        readOnly: props.inputContract.isReadOnly(),
        className: "form-control",
        value: new Date(internalValue).toLocaleString("sv-SE"),
        onChange: (e) => updateInternalValue(e.target.value),
        onBlur: checkIfValueChanged
      })]
    });
  }
  if (props.inputContract.widgetType === "boolean") {
    return jsxs(Fragment, {
      children: [props.showLabels && jsx("label", Object.assign({
        className: "text-secondary",
        htmlFor: props.propertyName
      }, {
        children: props.inputContract.title
      })), jsx("input", {
        id: props.propertyName,
        type: "checkbox",
        readOnly: props.inputContract.isReadOnly(),
        pattern: "\\d*",
        className: "form-control",
        checked: internalValue,
        onChange: (e) => updateInternalValue(String(e.target.checked)),
        onBlur: checkIfValueChanged
      })]
    });
  }
  if (props.inputContract.widgetType === "string" || props.inputContract.widgetType === "Currency" || props.inputContract.widgetType === "Tenor" || props.inputContract.widgetType === "TenorBucket" || props.inputContract.widgetType === "BusinessDayConvention" || props.inputContract.widgetType === "BdrParty" || props.inputContract.widgetType === "RateIndex") {
    return jsxs(Fragment, {
      children: [props.showLabels && jsx("label", Object.assign({
        className: "text-secondary",
        htmlFor: props.propertyName
      }, {
        children: props.inputContract.title
      })), !props.showLabels ? jsx(Fragment, {
        children: internalValue
      }) : jsx("input", {
        id: props.propertyName,
        type: "text",
        readOnly: props.inputContract.isReadOnly(),
        className: "form-control",
        value: internalValue,
        onChange: (e) => updateInternalValue(e.target.value),
        onBlur: checkIfValueChanged
      })]
    });
  }
  if (props.inputContract.widgetType === "number" || props.inputContract.widgetType === "Notional") {
    return jsxs(Fragment, {
      children: [props.showLabels && jsx("label", Object.assign({
        className: "text-secondary",
        htmlFor: props.propertyName
      }, {
        children: props.inputContract.title
      })), !props.showLabels ? jsx(Fragment, {
        children: internalValue
      }) : jsx("input", {
        id: props.propertyName,
        type: "numeric",
        readOnly: props.inputContract.isReadOnly(),
        className: "form-control text-right",
        value: internalValue,
        onChange: (e) => updateInternalValue(e.target.value),
        onBlur: checkIfValueChanged
      })]
    });
  }
  if (props.inputContract.widgetType === "integer") {
    return jsxs(Fragment, {
      children: [props.showLabels && jsx("label", Object.assign({
        className: "text-secondary",
        htmlFor: props.propertyName
      }, {
        children: props.inputContract.title
      })), !props.showLabels ? jsx(Fragment, {
        children: internalValue
      }) : jsx("input", {
        id: props.propertyName,
        type: "numeric",
        readOnly: props.inputContract.isReadOnly(),
        pattern: "\\d*",
        className: "form-control text-right",
        value: internalValue,
        onChange: (e) => updateInternalValue(e.target.value),
        onBlur: checkIfValueChanged
      })]
    });
  }
  return jsxs(Fragment, {
    children: [props.inputContract.title, " unknown widget type ", props.inputContract.widgetType]
  });
};
ScalarComponent.defaultProps = {
  showLabels: true
};

const ArrayComponent = ({
  propertyName,
  inputContract,
  nestedLevel,
  arrayModel
}) => {
  var _a;
  const [internalValue, setInternalValue] = React.useState([...(_a = arrayModel.Value) !== null && _a !== void 0 ? _a : []]);
  const refreshArrayModelValue = () => {
    var _a2;
    setInternalValue([...(_a2 = arrayModel.Value) !== null && _a2 !== void 0 ? _a2 : []]);
  };
  useEffect(() => {
    if (arrayModel.ModelStateUpdater) {
      console.error(`dynamic-screen array component: ${propertyName} already bound`);
    }
    arrayModel.ModelStateUpdater = () => refreshArrayModelValue();
    return () => arrayModel.ModelStateUpdater = void 0;
  }, []);
  if (inputContract.isArray() && inputContract.arrayItems) {
    return jsx(Fragment, {
      children: jsxs("div", Object.assign({
        className: "d-flex flex-column m-3 border"
      }, {
        children: [jsx("div", Object.assign({
          className: "bg-lvl2 p-1"
        }, {
          children: inputContract.title
        })), jsx("div", Object.assign({
          className: "m-2"
        }, {
          children: jsxs("div", Object.assign({
            className: "container"
          }, {
            children: [inputContract.arrayItems.isObject() && jsx("div", Object.assign({
              className: "row m-1"
            }, {
              children: inputContract.arrayItems.properties.map((p) => jsx("div", Object.assign({
                className: "text-secondary col font-xs"
              }, {
                children: p.title
              }), p.propertyName))
            })), internalValue === null || internalValue === void 0 ? void 0 : internalValue.map((model) => jsx(Fragment, {
              children: model instanceof ObjectDataModel ? jsx("div", Object.assign({
                className: "row m-1"
              }, {
                children: jsx(ObjectComponent, {
                  displayStyle: "inline",
                  nestedLevel: nestedLevel + 1,
                  objectModel: model
                }, inputContract.propertyName)
              })) : jsx("div", Object.assign({
                className: "row m-1"
              }, {
                children: jsx(ScalarComponent, {
                  propertyName: inputContract.propertyName,
                  inputContract: inputContract.arrayItems,
                  objectModel: model
                }, inputContract.propertyName)
              }))
            }))]
          }))
        }))]
      }))
    });
  }
  return jsx(Fragment, {});
};

const BdrPartyComponent = (props) => {
  const getAsInternalValue = (value) => {
    if (value === void 0 || value === null) {
      return "";
    }
    return value;
  };
  const mnemonic = props.objectModel.Fields.get("BdrMnemonic");
  const [internalValue, setInternalValue] = React.useState(getAsInternalValue(mnemonic.Value));
  const {
    applyPatch
  } = React.useContext(DynamicScreenContext);
  const refreshObjectModelValue = () => {
    setInternalValue(getAsInternalValue(mnemonic.Value));
  };
  useEffect(() => {
    if (mnemonic.ModelStateUpdater) {
      console.error(`dynamic-screen BdrParty component: ${props.propertyName} already bound`);
    } else {
      mnemonic.ModelStateUpdater = refreshObjectModelValue.bind(void 0);
    }
    return () => mnemonic.ModelStateUpdater = void 0;
  }, [props.objectModel]);
  const checkIfValueChanged = () => {
    if (getAsInternalValue(mnemonic.Value) !== internalValue) {
      mnemonic.Value = internalValue;
      const jsonPatchMessage = mnemonic.getJsonPatch();
      if (jsonPatchMessage) {
        applyPatch(jsonPatchMessage);
      }
    }
  };
  return jsxs("div", Object.assign({
    className: `form-group col-md-${props.inputContract.colNumber}`
  }, {
    children: [props.showLabels && jsx("label", Object.assign({
      className: "text-secondary",
      htmlFor: props.propertyName
    }, {
      children: props.inputContract.title
    })), !props.showLabels ? jsx(Fragment, {
      children: internalValue
    }) : jsx("input", {
      id: props.propertyName,
      type: "text",
      readOnly: props.inputContract.isReadOnly(),
      className: "form-control",
      value: internalValue,
      onChange: (e) => setInternalValue(e.target.value),
      onBlur: checkIfValueChanged
    })]
  }));
};
BdrPartyComponent.defaultProps = {
  showLabels: true
};

const BdrPortfolioComponent = (props) => {
  const getAsInternalValue = (value) => {
    if (value === void 0 || value === null) {
      return "";
    }
    return value;
  };
  const mnemonic = props.objectModel.Fields.get("BdrMnemonic");
  const [internalValue, setInternalValue] = React.useState(getAsInternalValue(mnemonic.Value));
  const {
    applyPatch
  } = React.useContext(DynamicScreenContext);
  const refreshObjectModelValue = () => {
    setInternalValue(getAsInternalValue(mnemonic.Value));
  };
  useEffect(() => {
    if (mnemonic.ModelStateUpdater) {
      console.error(`dynamic-screen BdrPortfolio component: ${props.propertyName} already bound`);
    } else {
      mnemonic.ModelStateUpdater = refreshObjectModelValue.bind(void 0);
    }
    return () => mnemonic.ModelStateUpdater = void 0;
  }, [props.objectModel]);
  const checkIfValueChanged = () => {
    if (getAsInternalValue(mnemonic.Value) !== internalValue) {
      mnemonic.Value = internalValue;
      const jsonPatchMessage = mnemonic.getJsonPatch();
      if (jsonPatchMessage) {
        applyPatch(jsonPatchMessage);
      }
    }
  };
  return jsxs("div", Object.assign({
    className: `form-group col-md-${props.inputContract.colNumber}`
  }, {
    children: [props.showLabels && jsx("label", Object.assign({
      className: "text-secondary",
      htmlFor: props.propertyName
    }, {
      children: props.inputContract.title
    })), !props.showLabels ? jsx(Fragment, {
      children: internalValue
    }) : jsx("input", {
      id: props.propertyName,
      type: "text",
      readOnly: props.inputContract.isReadOnly(),
      className: "form-control",
      value: internalValue,
      onChange: (e) => setInternalValue(e.target.value),
      onBlur: checkIfValueChanged
    })]
  }));
};
BdrPortfolioComponent.defaultProps = {
  showLabels: true
};

const XOneUserComponent = (props) => {
  const getAsInternalValue = (value) => {
    if (value === void 0 || value === null) {
      return "";
    }
    return value;
  };
  const initials = props.objectModel.Fields.get("BdrInitials");
  const [internalValue, setInternalValue] = React.useState(getAsInternalValue(initials.Value));
  const {
    applyPatch
  } = React.useContext(DynamicScreenContext);
  const refreshObjectModelValue = () => {
    setInternalValue(getAsInternalValue(initials.Value));
  };
  useEffect(() => {
    if (initials.ModelStateUpdater) {
      console.error(`dynamic-screen XOneUser component: ${props.propertyName} already bound`);
    } else {
      initials.ModelStateUpdater = refreshObjectModelValue.bind(void 0);
    }
    return () => initials.ModelStateUpdater = void 0;
  }, [props.objectModel]);
  const checkIfValueChanged = () => {
    if (getAsInternalValue(initials.Value) !== internalValue) {
      initials.Value = internalValue;
      const jsonPatchMessage = initials.getJsonPatch();
      if (jsonPatchMessage) {
        applyPatch(jsonPatchMessage);
      }
    }
  };
  return jsxs("div", Object.assign({
    className: `form-group col-md-${props.inputContract.colNumber}`
  }, {
    children: [props.showLabels && jsx("label", Object.assign({
      className: "text-secondary",
      htmlFor: props.propertyName
    }, {
      children: props.inputContract.title
    })), !props.showLabels ? jsx(Fragment, {
      children: internalValue
    }) : jsx("input", {
      id: props.propertyName,
      type: "text",
      readOnly: props.inputContract.isReadOnly(),
      className: "form-control",
      value: internalValue,
      onChange: (e) => setInternalValue(e.target.value),
      onBlur: checkIfValueChanged
    })]
  }));
};
XOneUserComponent.defaultProps = {
  showLabels: true
};

const RateComponent = ({
  propertyName,
  inputContract,
  objectModel,
  showLabels
}) => {
  const getAsInternalValue = (value) => {
    if (value === void 0 || value === null) {
      return NaN;
    }
    const numberValue = value;
    if (numberValue) {
      return numberValue * 100;
    }
    return value;
  };
  const [internalValue, setInternalValue] = React.useState(getAsInternalValue(objectModel.Value));
  const {
    applyPatch
  } = React.useContext(DynamicScreenContext);
  const refreshObjectModelValue = () => {
    setInternalValue(getAsInternalValue(objectModel.Value));
  };
  useEffect(() => {
    if (objectModel.ModelStateUpdater) {
      console.error(`dynamic-screen Rate component: ${propertyName} already bound`);
    } else {
      objectModel.ModelStateUpdater = refreshObjectModelValue.bind(void 0);
    }
    return () => objectModel.ModelStateUpdater = void 0;
  }, [objectModel]);
  const checkIfValueChanged = () => {
    if (getAsInternalValue(objectModel.Value) !== internalValue) {
      objectModel.Value = internalValue / 100;
      const jsonPatchMessage = objectModel.getJsonPatch();
      if (jsonPatchMessage) {
        applyPatch(jsonPatchMessage);
      }
    }
  };
  return jsxs(Fragment, {
    children: [showLabels && jsx("label", Object.assign({
      className: "text-secondary",
      htmlFor: propertyName
    }, {
      children: inputContract.title
    })), !showLabels ? jsx(Fragment, {
      children: internalValue
    }) : jsxs("div", Object.assign({
      className: "input-group"
    }, {
      children: [jsx("input", {
        id: propertyName,
        type: "numeric",
        readOnly: inputContract.isReadOnly(),
        className: "form-control text-right",
        value: internalValue,
        onChange: (e) => setInternalValue(e.target.value),
        onBlur: checkIfValueChanged
      }), jsx("div", Object.assign({
        className: "input-group-append"
      }, {
        children: jsx("span", Object.assign({
          className: "input-group-text"
        }, {
          children: "%"
        }))
      }))]
    }))]
  });
};
RateComponent.defaultProps = {
  showLabels: true
};

const SelectComponent = ({
  propertyName,
  inputContract,
  objectModel,
  enumValues,
  showLabels
}) => {
  const getAsInternalValue = (value) => {
    var _a;
    const stringValue = value;
    if (stringValue && enumValues.indexOf(stringValue) !== -1) {
      return stringValue;
    }
    return (_a = enumValues[0]) !== null && _a !== void 0 ? _a : "";
  };
  const [internalValue, setInternalValue] = React.useState(getAsInternalValue(objectModel.Value));
  const {
    applyPatch
  } = React.useContext(DynamicScreenContext);
  const refreshObjectModelValue = () => {
    setInternalValue(getAsInternalValue(objectModel.Value));
  };
  useEffect(() => {
    if (objectModel.ModelStateUpdater) {
      console.error(`dynamic-screen Select component: ${propertyName} already bound`);
    } else {
      objectModel.ModelStateUpdater = refreshObjectModelValue.bind(void 0);
      checkIfValueChanged();
    }
    return () => objectModel.ModelStateUpdater = void 0;
  }, [objectModel]);
  const checkIfValueChanged = () => {
    if (objectModel.Value !== internalValue) {
      objectModel.Value = internalValue;
      const jsonPatchMessage = objectModel.getJsonPatch();
      if (jsonPatchMessage) {
        applyPatch(jsonPatchMessage);
      }
    }
  };
  return jsxs(Fragment, {
    children: [showLabels && jsx("label", Object.assign({
      className: "text-secondary",
      htmlFor: propertyName
    }, {
      children: inputContract.title
    })), !showLabels ? jsx(Fragment, {
      children: internalValue
    }) : jsx("select", Object.assign({
      id: propertyName,
      disabled: inputContract.isReadOnly(),
      className: "form-control",
      value: internalValue,
      onChange: (e) => setInternalValue(e.target.value),
      onBlur: checkIfValueChanged
    }, {
      children: enumValues.map((value) => jsx("option", Object.assign({
        value
      }, {
        children: value
      })))
    }))]
  });
};
SelectComponent.defaultProps = {
  showLabels: true
};

const ObjectComponent = ({
  nestedLevel,
  objectModel,
  displayStyle,
  showTitle
}) => {
  if (displayStyle === "box") {
    const componentsPanel = jsx("div", Object.assign({
      className: `d-flex flex-row flex-wrap justify-content-begin ${nestedLevel === 0 ? "" : "m-2"}`
    }, {
      children: objectModel.InputContract.properties.filter((p) => !p.isHidden).map((property) => {
        if (property.isGroup()) {
          return jsx(ObjectComponent, {
            displayStyle: "box",
            nestedLevel: nestedLevel + 1,
            objectModel: objectModel.Fields.get(property.propertyName),
            showTitle: false
          }, property.propertyName);
        }
        if (property.isScalar()) {
          return jsx("div", Object.assign({
            className: `form-group col-md-${property.colNumber}`
          }, {
            children: property.widgetType === "Rate" ? jsx(Fragment, {
              children: jsx(RateComponent, {
                propertyName: property.propertyName,
                inputContract: property,
                objectModel: objectModel.Fields.get(property.propertyName)
              }, property.propertyName)
            }) : property.widgetType === "string" && property.enumValues ? jsx(Fragment, {
              children: jsx(SelectComponent, {
                propertyName: property.propertyName,
                inputContract: property,
                enumValues: property.enumValues,
                objectModel: objectModel.Fields.get(property.propertyName)
              }, property.propertyName)
            }) : jsx(ScalarComponent, {
              propertyName: property.propertyName,
              inputContract: property,
              objectModel: objectModel.Fields.get(property.propertyName)
            }, property.propertyName)
          }));
        }
        if (property.isObject()) {
          switch (property.widgetType) {
            case "Filler":
              return jsx("div", {
                className: `form-group col-md-${property.colNumber}`
              });
            case "BdrParty":
              return jsx(BdrPartyComponent, {
                propertyName: property.propertyName,
                inputContract: property,
                objectModel: objectModel.Fields.get(property.propertyName)
              }, property.propertyName);
            case "BdrPortfolio":
              return jsx(BdrPortfolioComponent, {
                propertyName: property.propertyName,
                inputContract: property,
                objectModel: objectModel.Fields.get(property.propertyName)
              }, property.propertyName);
            case "XOneUser":
              return jsx(XOneUserComponent, {
                propertyName: property.propertyName,
                inputContract: property,
                objectModel: objectModel.Fields.get(property.propertyName)
              }, property.propertyName);
            default:
              return jsx(ObjectComponent, {
                displayStyle: "box",
                nestedLevel: nestedLevel + 1,
                objectModel: objectModel.Fields.get(property.propertyName)
              }, property.propertyName);
          }
        }
        if (property.isArray()) {
          return jsx(ArrayComponent, {
            propertyName: property.propertyName,
            inputContract: property,
            nestedLevel: nestedLevel + 1,
            arrayModel: objectModel.Fields.get(property.propertyName)
          }, property.propertyName);
        }
        return jsx(Fragment, {});
      })
    }));
    return jsxs("div", Object.assign({
      className: `d-flex flex-column col-md-12 p-0 ${nestedLevel > 1 ? "mb-2 mt-2" : nestedLevel === 1 ? "m-1" : ""} ${nestedLevel === 0 || !showTitle ? "" : "border border-primary"}`
    }, {
      children: [nestedLevel > 0 && showTitle && jsxs("details", Object.assign({
        open: true,
        className: "col-md-12 p-0"
      }, {
        children: [jsx("summary", Object.assign({
          className: "btn btn-primary shadow-none text-left col-md-12",
          tabIndex: -1
        }, {
          children: objectModel.InputContract.title
        })), jsx("div", {
          children: componentsPanel
        })]
      })), (nestedLevel === 0 || !showTitle) && componentsPanel]
    }));
  }
  return jsxs(Fragment, {
    children: [objectModel.InputContract.properties.filter((property) => property.isScalar() && !property.isHidden).map((property) => jsx("div", Object.assign({
      className: "col"
    }, {
      children: jsx(ScalarComponent, {
        showLabels: false,
        propertyName: property.propertyName,
        inputContract: property,
        objectModel: objectModel.Fields.get(property.propertyName)
      }, property.propertyName)
    }))), objectModel.InputContract.properties.filter((property) => property.isObject() && !property.isHidden).map((property) => jsx("div", Object.assign({
      className: "col"
    }, {
      children: jsx(ObjectComponent, {
        displayStyle: "box",
        nestedLevel: nestedLevel + 1,
        objectModel: objectModel.Fields.get(property.propertyName)
      }, property.propertyName)
    }))), objectModel.InputContract.properties.filter((property) => property.isArray() && !property.isHidden).map((property) => jsx("div", Object.assign({
      className: "col"
    }, {
      children: jsx(ArrayComponent, {
        propertyName: property.propertyName,
        inputContract: property,
        nestedLevel: nestedLevel + 1,
        arrayModel: objectModel.Fields.get(property.propertyName)
      }, property.propertyName)
    })))]
  });
};
ObjectComponent.defaultProps = {
  showTitle: true
};

export { AccountCenter, AccountCenterReact, ArrayComponent, ArrayDataModel, DataContract, DynamicScreenContext, KeyDataModel, ObjectComponent, ObjectDataModel, ScalarComponent };
//# sourceMappingURL=main.es.js.map
